module.exports = __webpack_public_path__ + "webpc/img/icon_kefu.437dfac4.png";